import { useState } from "react";
// import {createUseStyles} from "react-jss";
import useAuth from "./useAuth";
import { AddEntrepot } from "$services/Entrepot.service";

const useWarehouseForm = ({ togglePopinExt }: { togglePopinExt?: any }) => {
  // const classes = useStyles();
  const { token, user } = useAuth();
  const userId = user?.userInfo?.id;

  const [submitting, setSubmitting] = useState(false);
  const [isOpened, setOpen] = useState<boolean>(false);
  const [error, setError] = useState<string>("");

  const openPopin = () => {
    setOpen(true);
  };

  const togglePopin = (isOpen: boolean) => {
    if (!isOpen) {
      setError("");
    }
    setOpen(isOpen);
  };

  const handleSubmit = async (data: any) => {
    setSubmitting(true);
    try {
      const result = await AddEntrepot(token, {
        ...data,
        createdBy: data?.createdBy ? data.createdBy : userId,
      });
      if (result?.error) {
        setError(result.error || "Erreur Serveur");
      } else {
        togglePopinExt?.();
        setOpen(false);
      }
      return result;
    } finally {
      setSubmitting(false);
    }
  };

  return {
    // classes,
    error,
    handleSubmit,
    isOpened,
    openPopin,
    submitting,
    togglePopin,
  };
};

export default useWarehouseForm;
